import { getGoldBotPerformance } from "../services/goldBotPerformanceApi";
import { useGoldBotResource } from "./useGoldBotResource";

export const GOLD_BOT_PERFORMANCE_POLL_INTERVAL_MS = 30000;

export function useGoldBotPerformance() {
  return useGoldBotResource(
    getGoldBotPerformance,
    GOLD_BOT_PERFORMANCE_POLL_INTERVAL_MS
  );
}
